
import { fetchJSON, POST, GET, fetchPublicCOACH } from 'utils/http';
import { GET_SA_DASHBOARD_SCHOOLS, ADD_TO_WISHLIST, ADD_TO_REQUEST, GET_SA_DASHBOARD_POSTINGS,
    GET_COACH_DASHBOARD_REQUESTS, REMOVE_FROM_LIST, ADD_CONVERSATION, COACH_GET_REQUEST_LIST,
    GET_TOTAL_COUNTS_FOR_DASHBOARD, ADD_STUDENT_CURRENT_DIVISION, GET_DIVISION_BASED_STUDENTS,
    GET_FILTER_BASED_STUDENTS, GET_TOTAL_REQUEST_VIEWED_COUNT } from 'constants/urls';


export function getSchools(payload) {
  return fetchJSON(GET_SA_DASHBOARD_SCHOOLS, POST, {}, payload, {});
}

export function getPostings(payload) {
  return fetchJSON(GET_SA_DASHBOARD_POSTINGS, POST, {}, payload, {});
}

export function addToWishList(payload) {
  return fetchJSON(ADD_TO_WISHLIST, POST, {}, payload, {});
}

export function removeFromList(payload) {
  return fetchJSON(REMOVE_FROM_LIST, POST, {}, payload, {});
}

export function addToRequest(payload) {
  return fetchJSON(ADD_TO_REQUEST, POST, {}, payload, {});
}

export function getRequests(id) {
  return fetchJSON(GET_COACH_DASHBOARD_REQUESTS + id, GET, {}, {}, {});
}

export function getRequestsCoach(id) {
  return fetchJSON(COACH_GET_REQUEST_LIST + id, GET, {}, {}, {});
}

export function addConversation(data, place) {
  if (place === 'public') {
    return fetchPublicCOACH(ADD_CONVERSATION, POST, data);
  }
  return fetchJSON(ADD_CONVERSATION, POST, {}, data, {});
}

export function totalCountsForDashboard(data) {
  return fetchJSON(GET_TOTAL_COUNTS_FOR_DASHBOARD, POST, {}, data, {});
}

export function addStudentCurrentDivision(payload) {
  return fetchJSON(ADD_STUDENT_CURRENT_DIVISION, POST, {}, payload, {});
}

export function getdivisionstudents() {
  return fetchJSON(GET_DIVISION_BASED_STUDENTS, GET, {}, {}, {});
}

export function getfilterbasedstudents(payload) {
  return fetchJSON(GET_FILTER_BASED_STUDENTS, POST, {}, payload, {});
}

export function getTotalRequestViewedCount(id) {
  return fetchJSON(GET_TOTAL_REQUEST_VIEWED_COUNT + id, GET, {}, {}, {});
}



// WEBPACK FOOTER //
// ./src/common/services/dashboard.service/service.js